import { GeoPoint } from 'firebase/firestore';
import { selector } from 'recoil';
import remotePickMealPointsListAtom from '~/recoil/atom/remotePickMealPointsList';
import remotePickMealPointAtom from '~/recoil/atom/remotePickMealPoint';

import { RemotePickMealPointWithId } from '~/types/platform/remotePickMealPoint';

import { emptyOperatingTime } from '~/types/utilities';

const defaultPickMealPoint = {
  id: '',
  name: '',
  image: '',
  description: '',
  operatingTime: emptyOperatingTime,
  location: {
    address: '',
    geoPoint: new GeoPoint(0, 0),
  },
  stores: [],
  phoneNumber: '',
  shippingFeeSetting: {
    baseFee: 0,
    freeLimit: Infinity,
    rates: [],
    priceThreshold: [],
    subsidies: [],
    cashHandlingFeeForCustomer: 0,
  },
};

const currentPickMealPoint = selector<RemotePickMealPointWithId>({
  key: 'currentPickMealPoint',
  get: ({ get }) => {
    const remotePickMealPointsList = get(remotePickMealPointsListAtom);
    const remotePickMealPoint = get(remotePickMealPointAtom);

    const pickMealPoint = remotePickMealPointsList.find(({ id }) => remotePickMealPoint?.id === id);

    return pickMealPoint || defaultPickMealPoint;
  },
});

export default currentPickMealPoint;
